// App
export const SET_LOADING = 'SET_LOADING'
export const SET_APP_ERROR = 'SET_APP_ERROR'
export const APP_GET_PAYROLL_PERIODS_REQUEST = 'APP_GET_PAYROLL_PERIODS_REQUEST'
export const APP_GET_PAYROLL_PERIODS_SUCCESS = 'APP_GET_PAYROLL_PERIODS_SUCCESS'
export const APP_GET_PAYROLL_PERIODS_FAILURE = 'APP_GET_PAYROLL_PERIODS_FAILURE'
export const APP_LOGOUT = 'APP_LOGOUT'

// User
export const CURRENT_USER_REQUEST = 'CURRENT_USER_REQUEST'
export const CURRENT_USER_SUCCESS = 'CURRENT_USER_SUCCESS'
export const CURRENT_USER_FAILURE = 'CURRENT_USER_FAILURE'
export const CURRENT_USER_EDIT_REQUEST = 'CURRENT_USER_EDIT_REQUEST'
export const CURRENT_USER_EDIT_SUCCESS = 'CURRENT_USER_EDIT_SUCCESS'
export const CURRENT_USER_EDIT_FAILURE = 'CURRENT_USER_EDIT_FAILURE'

// Authentication
export const AUTH_SET_TENANT = 'AUTH_SET_TENANT'
export const AUTH_SET_API_TOKEN = 'AUTH_SET_API_TOKEN'
export const AUTH_SET_REFRESH_TOKEN = 'AUTH_SET_REFRESH_TOKEN'
export const AUTH_UNSET_TOKENS = 'AUTH_UNSET_TOKENS'
export const AUTH_AUTHENTICATE_USER_REQUEST = 'AUTH_AUTHENTICATE_USER_REQUEST'
export const AUTH_AUTHENTICATE_USER_SUCCESS = 'AUTH_AUTHENTICATE_USER_SUCCESS'
export const AUTH_AUTHENTICATE_USER_FAILURE = 'AUTH_AUTHENTICATE_USER_FAILURE'
export const AUTH_SUBMIT_PASSWORD_REQUEST = 'AUTH_SUBMIT_PASSWORD_REQUEST'
export const AUTH_SUBMIT_PASSWORD_SUCCESS = 'AUTH_SUBMIT_PASSWORD_SUCCESS'
export const AUTH_SUBMIT_PASSWORD_FAILURE = 'AUTH_SUBMIT_PASSWORD_FAILURE'
export const AUTH_FORGOT_PASSWORD_REQUEST = 'AUTH_FORGOT_PASSWORD_REQUEST'
export const AUTH_FORGOT_PASSWORD_SUCCESS = 'AUTH_FORGOT_PASSWORD_SUCCESS'
export const AUTH_FORGOT_PASSWORD_FAILURE = 'AUTH_FORGOT_PASSWORD_FAILURE'

// Tracks
export const TRACKS_REQUEST = 'TRACKS_REQUEST'
export const TRACKS_SUCCESS = 'TRACKS_SUCCESS'
export const TRACKS_FAILURE = 'TRACKS_FAILURE'

// Track
export const TRACK_REQUEST = 'TRACK_REQUEST'
export const TRACK_SUCCESS = 'TRACK_SUCCESS'
export const TRACK_FAILURE = 'TRACK_FAILURE'

// Shifts
export const SHIFTS_REQUEST = 'SHIFTS_REQUEST'
export const SHIFTS_FAILURE = 'SHIFTS_FAILURE'
export const SHIFTS_PLANNED_SUCCESS = 'SHIFTS_PLANNED_SUCCESS'
export const SHIFTS_OPEN_SUCCESS = 'SHIFTS_OPEN_SUCCESS'

// ExchangeShifts
export const EXCHANGE_SHIFTS_REQUEST = 'EXCHANGE_SHIFTS_REQUEST'
export const EXCHANGE_SHIFTS_FAILURE = 'EXCHANGE_SHIFTS_FAILURE'
export const EXCHANGE_SHIFTS_PLANNED_SUCCESS = 'EXCHANGE_SHIFTS_PLANNED_SUCCESS'
export const EXCHANGE_SHIFTS_OPEN_SUCCESS = 'EXCHANGE_SHIFTS_OPEN_SUCCESS'
export const EXCHANGE_SUCCESS = 'EXCHANGE_SUCCESS'

// ShiftExchange
export const EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_REQUEST = 'EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_REQUEST'
export const EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_SUCCESS = 'EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_SUCCESS'
export const EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_FAILURE = 'EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGES_FAILURE'
export const EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_REQUEST = 'EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_REQUEST'
export const EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_SUCCESS = 'EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_SUCCESS'
export const EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_FAILURE = 'EXCHANGE_SHIFTS_GET_SHIFT_EXCHANGE_FAILURE'
export const EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_REQUEST = 'EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_REQUEST'
export const EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_SUCCESS = 'EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_SUCCESS'
export const EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_FAILURE = 'EXCHANGE_SHIFTS_CANCEL_SHIFT_EXCHANGE_FAILURE'
export const EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_REQUEST = 'EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_REQUEST'
export const EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_SUCCESS = 'EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_SUCCESS'
export const EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_FAILURE = 'EXCHANGE_SHIFTS_ACCEPT_SHIFT_EXCHANGE_FAILURE'
export const EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_REQUEST = 'EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_REQUEST'
export const EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_SUCCESS = 'EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_SUCCESS'
export const EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_FAILURE = 'EXCHANGE_SHIFTS_SUBMIT_SHIFT_EXCHANGE_FAILURE'

// Shift
export const SHIFT_REQUEST = 'SHIFT_REQUEST'
export const SHIFT_SUCCESS = 'SHIFT_SUCCESS'
export const SHIFT_FAILURE = 'SHIFT_FAILURE'

// Feedback
export const FEEDBACK_REQUEST = 'FEEDBACK_REQUEST'
export const FEEDBACK_SUCCESS = 'FEEDBACK_SUCCESS'
export const FEEDBACK_SUBMIT = 'FEEDBACK_SUBMIT'
export const FEEDBACK_SUBMIT_SUCCESS = 'FEEDBACK_SUBMIT_SUCCESS'
export const FEEDBACK_SUBMIT_FAILURE = 'FEEDBACK_SUBMIT_FAILURE'
export const FEEDBACK_FAILURE = 'FEEDBACK_FAILURE'

// Feedback Categories
export const FEEDBACK_CATEGORIES_SUCCESS = 'FEEDBACK_CATEGORIES_SUCCESS'
export const FEEDBACK_CATEGORIES_FAILURE = 'FEEDBACK_CATEGORIES_FAILURE'

// Week Navigator

// Leave of absences
export const LEAVE_OF_ABSENCES_REQUEST = 'LEAVE_OF_ABSENCES_REQUEST'
export const LEAVE_OF_ABSENCES_SUCCESS = 'LEAVE_OF_ABSENCES_SUCCESS'
export const LEAVE_OF_ABSENCES_FAILURE = 'LEAVE_OF_ABSENCES_FAILURE'

// Absences
export const ABSENCES_REQUEST = 'ABSENCES_REQUEST'
export const ABSENCES_FAILURE = 'ABSENCES_FAILURE'
export const ABSENCES_GET_CURRENT_PAYROLL_PERIOD_REQUEST = 'ABSENCES_GET_CURRENT_PAYROLL_PERIOD_REQUEST'
export const ABSENCES_GET_CURRENT_PAYROLL_PERIOD_SUCCESS = 'ABSENCES_GET_CURRENT_PAYROLL_PERIOD_SUCCESS'
export const ABSENCES_GET_CURRENT_PAYROLL_PERIOD_FAILURE = 'ABSENCES_GET_CURRENT_PAYROLL_PERIOD_FAILURE'
export const ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_REQUEST = 'ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_REQUEST'
export const ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_SUCCESS = 'ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_SUCCESS'
export const ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_FAILURE = 'ABSENCES_GET_EMPLOYEE_LOKET_BALANCES_FAILURE'

// Registration

// Leave of absence

// Documents
export const DOCUMENTS_GET_DOCUMENTS_FOR_ME_SUCCESS = 'DOCUMENTS_GET_DOCUMENTS_FOR_ME_SUCCESS'
export const DOCUMENTS_REQUEST = 'DOCUMENTS_REQUEST'
export const DOCUMENTS_FAILURE = 'DOCUMENTS_FAILURE'

// Preference days
export const PREFERENCE_GET_PLANNING_PREFERENCES_REQUEST = 'PREFERENCE_GET_PLANNING_PREFERENCES_REQUEST'
export const PREFERENCE_GET_PLANNING_PREFERENCES_SUCCESS = 'PREFERENCE_GET_PLANNING_PREFERENCES_SUCCESS'
export const PREFERENCE_GET_PLANNING_PREFERENCES_FAILURE = 'PREFERENCE_GET_PLANNING_PREFERENCES_FAILURE'
export const PREFERENCE_GET_PLANNING_PREFERENCE_REQUEST = 'PREFERENCE_GET_PLANNING_PREFERENCE_REQUEST'
export const PREFERENCE_GET_PLANNING_PREFERENCE_SUCCESS = 'PREFERENCE_GET_PLANNING_PREFERENCE_SUCCESS'
export const PREFERENCE_GET_PLANNING_PREFERENCE_FAILURE = 'PREFERENCE_GET_PLANNING_PREFERENCE_FAILURE'
export const PREFERENCE_CREATE_PLANNING_PREFERENCE_REQUEST = 'PREFERENCE_CREATE_PLANNING_PREFERENCE_REQUEST'
export const PREFERENCE_CREATE_PLANNING_PREFERENCE_SUCCESS = 'PREFERENCE_CREATE_PLANNING_PREFERENCE_SUCCESS'
export const PREFERENCE_CREATE_PLANNING_PREFERENCE_FAILURE = 'PREFERENCE_CREATE_PLANNING_PREFERENCE_FAILURE'
export const PREFERENCE_DEL_PLANNING_PREFERENCE_REQUEST = 'PREFERENCE_DEL_PLANNING_PREFERENCE_REQUEST'
export const PREFERENCE_DEL_PLANNING_PREFERENCE_SUCCESS = 'PREFERENCE_DEL_PLANNING_PREFERENCE_SUCCESS'
export const PREFERENCE_DEL_PLANNING_PREFERENCE_FAILURE = 'PREFERENCE_DEL_PLANNING_PREFERENCE_FAILURE'
export const PREFERENCE_FAILURE = 'PREFERENCE_FAILURE'
